<script setup lang="ts">
import { PropType } from 'vue'

import { Factoid } from '@/types/api/api-v3/slider'

const props = defineProps({
  factoid: {
    type: Object as PropType<Factoid>,
    required: true,
  },
  isCategoryPage: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>

<template>
  <nuxt-link :to="props.factoid.url" class="factoid">
    <nuxt-img
      :src="props.factoid.image"
      width="270"
      height="410"
      format="webp"
      alt=""
      class="factoid__image"
    />
    <div class="factoid__text">
      <span class="factoid__title">{{ props.factoid.title }}</span>
      <div
        v-if="props.factoid.description && isCategoryPage"
        class="factoid__desc"
      >
        {{ props.factoid.description }}
      </div>
    </div>
  </nuxt-link>
</template>

<style lang="scss" scoped>
.factoid {
  position: relative;
  display: block;
  width: 270px;
  height: 100%;
  max-height: 410px;
  cursor: pointer;
  @include media('>=tablet', '<=desktop-mini') {
    height: 100%;
    min-height: 327px;
  }
  @include media('<=tablet') {
    width: 100%;
    height: 90%;
    min-height: 240px;
  }
  @include media('<=portrait-phone') {
    height: 90%;
    min-height: 240px;
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 30px;
  }

  &__text {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    padding: 40px 36px;
    @include media('>=tablet', '<=desktop-mini') {
      padding: 30px 25px;
    }
    @include media('<=tablet') {
      padding: 24px 20px;
    }
  }

  &__title {
    display: block;
    max-width: 200px;
    margin: 0;
    font-size: 26px;
    font-weight: 900;
    line-height: 31px;
    color: $white;
    @include media('>=tablet', '<=desktop-mini') {
      font-size: 20px;
    }
    @include media('<=tablet') {
      font-size: 16px;
      line-height: 19px;
    }
  }

  &__desc {
    margin-top: 5px;
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
    color: $white;
    @include media('<=desktop-mini') {
      font-size: 12px;
    }
  }
}
</style>
